package dev.lingvo.site.components.marketing

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.style.toModifier
import dev.lingvo.shared.agent.AgentClient
import dev.lingvo.site.ds.LCodeBlock
import dev.lingvo.site.ds.Space
import dev.lingvo.site.i18n.t
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun DocsWelcome() {
    Div(DocsWelcomeStyle.toModifier().toAttrs()) {
        Column(DocsWelcomeStartStyle.toModifier().gap(Space.XL)) {
            H2(AgentSetupStepTitleStyle.toModifier().toAttrs()) { Text(t("marketing.docs_welcome.start_with_your_repo", "Start with your repository")) }
            P(AgentSetupNoteStyle.toModifier().toAttrs()) { Text(t("marketing.docs_welcome.cli_description", "Connect the files you already have. Push source strings, review translations, then pull them back into your app.")) }
            LCodeBlock("brew install merkost/lingvo/lingvo\nlingvo login --device\nlingvo init", t("marketing.docs_welcome.quick_start", "macOS quick start"), copyable = true)
            PublicActionLink("/docs/cli", t("marketing.docs_welcome.open_cli_guide", "Follow the CLI guide"))
            DocsProse { DocsInlineLink("/docs/cli#install", t("marketing.docs_welcome.other_systems", "Windows, Linux and other installation options")) }
        }
        Column(Modifier.fillMaxWidth().gap(Space.XL).styleModifier { property("min-width", "0") }) {
            Link(path = "/agents#setup", modifier = DocsWelcomeLinkStyle.toModifier(), variant = UndecoratedLinkVariant.then(UncoloredLinkVariant)) {
                Div(Modifier.gap(Space.MD).styleModifier { property("display", "flex") }.toAttrs()) {
                    listOf(AgentClient.CLAUDE_CODE, AgentClient.CODEX, AgentClient.CURSOR).forEach { AgentClientLogo(it) }
                }
                H2(AgentSetupStepTitleStyle.toModifier().toAttrs()) { Text(t("marketing.docs_welcome.connect_agent", "Connect your coding agent")) }
                P(AgentSetupNoteStyle.toModifier().toAttrs()) { Text(t("marketing.docs_welcome.agent_description", "Give Claude Code, Codex or Cursor shared localization context, a proposal queue and repeatable QA.")) }
                Text(t("marketing.docs_welcome.choose_client", "Choose your client →"))
            }
            DocsProse { DocsInlineLink("/agents#why-lingvo", t("marketing.docs_welcome.why_add_lingvo", "Already using an agent? See what Lingvo adds.")) }
            Link(path = "/docs/cli/commands", modifier = DocsWelcomeLinkStyle.toModifier(), variant = UndecoratedLinkVariant.then(UncoloredLinkVariant)) {
                H2(AgentSetupStepTitleStyle.toModifier().toAttrs()) { Text(t("marketing.docs_welcome.command_reference", "Find a command")) }
                P(AgentSetupNoteStyle.toModifier().toAttrs()) { Text(t("marketing.docs_welcome.reference_description", "Every command, flag and default, grouped by the work you want to do.")) }
                Text(t("marketing.docs_welcome.browse_reference", "Browse the reference →"))
            }
        }
    }
}
